import { useMemo } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { PetitionPhoto } from '#src/app/pages/petitionDetails/shared/types';
import { useProcessedImage } from '#src/app/shared/hooks/image';

// value set by the petition create/edit mutations for photos generated with AI
// (CreatePublishedPetitionPhotoType.AI_GENERATED, lowercased by the middle-end)
const AI_GENERATED_TAG = 'ai_generated';

export function usePhoto(): PetitionPhoto | undefined {
	const {
		data: {
			petition: { photo },
		},
	} = usePetitionDetailsPageData();
	const photoSmall = useProcessedImage(photo?.petitionSmall);
	const photoMedium = useProcessedImage(photo?.petitionMedium);
	const aiGenerated = photo?.metadata?.tag === AI_GENERATED_TAG;

	return useMemo(() => {
		if (!photoSmall || !photoMedium) return undefined;

		return {
			mobileUrl: photoSmall.url,
			url: photoMedium.url,
			processing: photoSmall.processing || photoMedium.processing,
			aiGenerated,
			palette: photoSmall.palette,
		};
	}, [photoSmall, photoMedium, aiGenerated]);
}
